var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading ? _c("div", [_c("loading-spinner")], 1) : _vm._e(),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          [
            _c("b-breadcrumb", { attrs: { items: _vm.navigationItems } }),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "deletePayment",
                attrs: {
                  id: "delete-payment",
                  title: "Delete Alternative Payment Configuration"
                },
                on: {
                  ok: _vm.handleDeleteOK,
                  hidden: function($event) {
                    _vm.resetModal("delete-payment")
                  }
                }
              },
              [
                _c("p", [
                  _vm._v("Are you sure you want to delete : "),
                  _c("b", [_vm._v(_vm._s(_vm.payment.name))])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "b-container",
              [
                _c(
                  "b-row",
                  { attrs: { "align-v": "center" } },
                  [
                    _c("b-col", { staticClass: "pl-0", attrs: { cols: "6" } }, [
                      _c("h2", { staticStyle: { display: "inline" } }, [
                        _vm._v(
                          "\n            Alternative Payments for " +
                            _vm._s(
                              _vm.clientName.text
                                ? _vm.clientName.text
                                : "Please select a Publisher"
                            ) +
                            "\n          "
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-v": "center" } },
                  [
                    _c(
                      "b-col",
                      { staticClass: "form-row", attrs: { cols: "6" } },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "navigation-links",
                            attrs: {
                              to: {
                                name: "configuration",
                                params: { clientId: _vm.clientId }
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            View Configurations\n          "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "form-row",
                        attrs: { cols: "6", "align-h": "end" }
                      },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "text-right align-self-center",
                            attrs: { cols: "5" }
                          },
                          [
                            _c("label", { attrs: { for: "table-search" } }, [
                              _vm._v("Search:")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "7" } },
                          [
                            _c("b-form-input", {
                              attrs: { id: "table-search", type: "text" },
                              model: {
                                value: _vm.search,
                                callback: function($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-table", {
                      directives: [
                        { name: "b-scrollspy", rawName: "v-b-scrollspy" }
                      ],
                      attrs: {
                        outlined: "",
                        striped: "",
                        hover: "",
                        items: _vm.items,
                        "head-variant": "light",
                        fields: _vm.computeTableFields,
                        "current-page": _vm.currentPage,
                        "show-empty": "",
                        "empty-text":
                          "No alternative payments created for selected publisher.",
                        "per-page": _vm.perPage,
                        filter: _vm.search,
                        "sort-by": _vm.sortBy,
                        "sort-desc": _vm.sortDesc,
                        "sort-compare": _vm.sortCompareForPayments
                      },
                      on: {
                        "update:sortBy": function($event) {
                          _vm.sortBy = $event
                        },
                        "update:sort-by": function($event) {
                          _vm.sortBy = $event
                        },
                        "update:sortDesc": function($event) {
                          _vm.sortDesc = $event
                        },
                        "update:sort-desc": function($event) {
                          _vm.sortDesc = $event
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "cell(paymentId)",
                            fn: function(data) {
                              return [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "navigation-links",
                                    attrs: {
                                      to: {
                                        name: "editAlternativePayment",
                                        params: {
                                          clientId: _vm.clientId,
                                          paymentType: data.item.processor,
                                          paymentId: data.item.paymentId
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(data.item.paymentId) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(processor)",
                            fn: function(data) {
                              return [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "/static/images/logos/" +
                                      _vm.logos[data.item.processor],
                                    height: "40",
                                    alt: "data.item.processor"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(expiresAt)",
                            fn: function(data) {
                              return [
                                data.item.expiresAt
                                  ? _c("div", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            data.item.expiresAt.toLocaleDateString()
                                          ) +
                                          " " +
                                          _vm._s(
                                            data.item.expiresAt.toLocaleTimeString()
                                          ) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "cell(action)",
                            fn: function(data) {
                              return [
                                !data.item.expiresAt
                                  ? _c(
                                      "b-link",
                                      {
                                        directives: [
                                          {
                                            name: "b-modal",
                                            rawName: "v-b-modal",
                                            value: "delete-payment",
                                            expression: "'delete-payment'"
                                          }
                                        ],
                                        staticClass: "navigation-links",
                                        on: {
                                          click: function($event) {
                                            return _vm.updateDeletedItem(
                                              data.item
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Delete\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                data.item.expiresAt
                                  ? _c(
                                      "b-link",
                                      {
                                        staticClass: "navigation-links",
                                        on: {
                                          click: function($event) {
                                            return _vm.restorePayment(data.item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Restore\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3174293573
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showPagination,
                            expression: "showPagination"
                          }
                        ]
                      },
                      [
                        _c("b-pagination", {
                          attrs: {
                            "total-rows": _vm.totalRows,
                            "per-page": _vm.perPage,
                            align: "center"
                          },
                          model: {
                            value: _vm.currentPage,
                            callback: function($$v) {
                              _vm.currentPage = $$v
                            },
                            expression: "currentPage"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-modal",
                  {
                    ref: "new-payment",
                    attrs: {
                      id: "new-payment",
                      title: "Create Alternative Payment"
                    },
                    on: {
                      show: function($event) {
                        return _vm.resetModal("new-payment")
                      },
                      hidden: function($event) {
                        return _vm.resetModal("new-payment")
                      },
                      ok: _vm.handleOk
                    }
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "This will create a new alternative payment with a randomly generated unique ID."
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        ref: "form",
                        on: {
                          submit: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.handleSubmit($event)
                          }
                        }
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Name",
                              "label-for": "name-input",
                              "invalid-feedback": "Name is required"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "name-input",
                                state: _vm.validateState("name")
                              },
                              model: {
                                value: _vm.$v.form.name.$model,
                                callback: function($$v) {
                                  _vm.$set(_vm.$v.form.name, "$model", $$v)
                                },
                                expression: "$v.form.name.$model"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Type",
                              "label-for": "payment-type-select",
                              "invalid-feedback": "Payment type is required"
                            }
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                id: "payment-type-select",
                                options: _vm.paymentTypes,
                                state: _vm.validateState("paymentType")
                              },
                              model: {
                                value: _vm.$v.form.paymentType.$model,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$v.form.paymentType,
                                    "$model",
                                    $$v
                                  )
                                },
                                expression: "$v.form.paymentType.$model"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "button-action-ct" },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.new-payment",
                            modifiers: { "new-payment": true }
                          }
                        ],
                        attrs: { variant: "primary" }
                      },
                      [_vm._v("\n          New Alternative Payment\n        ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }